import { render } from "./StoryContent.vue.js?vue&type=template&id=56118ca5!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContent.vue?vue&type=template&id=56118ca5"
import script from "./StoryContent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContent.vue?vue&type=script&lang=js"
export * from "./StoryContent.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/StoryContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56118ca5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56118ca5', __exports__)) {
    api.reload('56118ca5', __exports__)
  }
  
  module.hot.accept("./StoryContent.vue.js?vue&type=template&id=56118ca5!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContent.vue?vue&type=template&id=56118ca5", () => {
    api.rerender('56118ca5', render)
  })

}


export default __exports__